import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'

export const initialState = {
  showAds: false,
}

export const ad = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.AD_VISIBILITY_CHANGE, (state, action) => adVisibilityChange(state, action))
    .addCase(ActionTypes.AD_CHANNEL_CHANGE, (state, action) => adChannelChange(state, action))
})

function adVisibilityChange(state, action) {
  const { payload } = action
  state.showAds = payload
  return state
}

function adChannelChange(state, action) {
  const { payload } = action
  state.adChannel = payload
  return state
}

export default ad
